/** Connection quality shown to online players: 3 = good, 2 = fair, 1 = poor, 0 = no news from the server. */
export const STALL_MS = 1500; // nothing received for this long: the link is stalling
export function quality(rttMs: number, sinceLastMsgMs: number): 0 | 1 | 2 | 3 {
  if (sinceLastMsgMs > STALL_MS) return 0;
  if (rttMs <= 90) return 3;
  if (rttMs <= 180) return 2;
  return 1;
}
/** Smoothed round-trip time: the first sample is taken as is, then 20% of each new one. */
export const smooth = (avg: number, sample: number) => (avg <= 0 ? sample : avg + (sample - avg) * 0.2);
